import { ReactNode } from "react"

interface RenderResourceNameProps {
  name: string | ReactNode
}

export const RenderResourceName = ({ name }: RenderResourceNameProps) => {
  if (typeof name === "string") {
    return <b>{name}</b>
  }
  return <>{name}</>
}
